<oaibox-stats-card
  title="Serial Number Update"
  icon="fa-solid fa-shield-halved"
  gradient="primary"
>
  <div class="p-g">
    <oaibox-machine-details [machine]="machine"></oaibox-machine-details>
  </div>
  <form class="form p-g" [formGroup]="machineSerialNumberUpdateForm">
    <div>
      <label class="form-label">Machine Serial Number</label>
      <input
        type="text"
        class="form-control"
        id="serialNumber"
        formControlName="serialNumber"
      />
    </div>
  </form>
  <div class="modal-buttons-container p-g">
    <button class="btn btn-ignore" (click)="cancel()">Cancel</button>
    <button
      class="btn btn-primary"
      (click)="save()"
      [disabled]="requestOnGoing || machineSerialNumberUpdateForm.invalid"
    >
      Save
      @if (requestOnGoing) {
        <i class="fa-solid fa-spinner rotating"></i>
      }
    </button>
  </div>
</oaibox-stats-card>
